import React from 'react';
import CheckeredFlagIcon from '../CheckeredFlagIcon';
import './styles.css';

const DEFAULT_TOP_NODE_WIDTH = 288;

/**
 * Origin marker centered above a chain's top row.
 * Flag + stem; hover reveals left/right reorder.
 */
const ChainHeader = ({
  chainId,
  order,
  totalChains,
  position,
  width,
  onMoveLeft,
  onMoveRight,
  isDragging = false,
  isMultiCampaignMode = false,
  campaignColor,
}) => {
  const handleMoveLeft = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onMoveLeft?.(chainId);
  };

  const handleMoveRight = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onMoveRight?.(chainId);
  };

  const handleMouseDown = (e) => {
    e.stopPropagation();
  };

  const showReorderButtons = !isMultiCampaignMode && (onMoveLeft || onMoveRight);
  const canMoveLeft = showReorderButtons && order > 0;
  const canMoveRight = showReorderButtons && order < totalChains - 1;
  const originX = Number.isFinite(position?.x) ? position.x : 0;
  const originY = Number.isFinite(position?.y) ? position.y : 0;
  const span = Number.isFinite(width) && width > 0 ? width : DEFAULT_TOP_NODE_WIDTH;
  const centerX = originX + span / 2;

  return (
    <div
      className={`chain-origin ${isDragging ? 'chain-origin--dragging' : ''} ${isMultiCampaignMode ? 'chain-origin--multi-campaign' : ''}`}
      data-board-origin={chainId}
      style={{
        left: centerX,
        top: originY,
        '--chain-color': campaignColor || 'var(--text-tertiary)',
      }}
      onMouseDown={handleMouseDown}
    >
      <div className="chain-origin__stack">
        <div className="chain-origin__label">
          {showReorderButtons && (
            <button
              className={`chain-origin__arrow ${!canMoveLeft ? 'chain-origin__arrow--disabled' : ''}`}
              onClick={handleMoveLeft}
              onMouseDown={handleMouseDown}
              disabled={!canMoveLeft}
              title="Move chain left"
            >
              <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}

          <span className="chain-origin__flag" aria-hidden="true">
            <CheckeredFlagIcon
              size={18}
              color={isMultiCampaignMode ? campaignColor : undefined}
            />
          </span>

          {showReorderButtons && (
            <button
              className={`chain-origin__arrow ${!canMoveRight ? 'chain-origin__arrow--disabled' : ''}`}
              onClick={handleMoveRight}
              onMouseDown={handleMouseDown}
              disabled={!canMoveRight}
              title="Move chain right"
            >
              <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}
        </div>

        <div className="chain-origin__connector" aria-hidden="true">
          <span className="chain-origin__line" />
          <span className="chain-origin__junction" />
          <span className="chain-origin__line chain-origin__line--end" />
        </div>
      </div>
    </div>
  );
};

export default ChainHeader;
